<template>
    <div class="p-4 bg-gray-50 border border-gray-200 rounded-xl">
        <ui-form-section class="mb-4">
            <ui-date-picker label="Date" name="date" :error="form.errors.get('date')" v-model="form.date"
                            :max-date="new Date()"
                            placeholder="Inspection Date..."></ui-date-picker>
            <ui-input label="Type" name="type" :error="form.errors.get('type')" v-model="form.type"
                      placeholder="LOLER, PUWER, PAT Test, Functional Test..."
                      class="xl:col-span-6"></ui-input>
            <ui-select-searchable
                label="Carried Out By"
                placeholder="This work was carried out by..."
                v-model="form.carried_out_by"
                :error="form.errors.get('carried_out_by_id')"
                :search="searchSuppliers"
                no-search="Start typing to find people or companies..."
                class="xl:col-span-6"
            ></ui-select-searchable>
            <ui-input-file preview multiple label="Attachments &amp; Certificates" name="attachments"
                           :error="form.errors.get('attachments')" v-model="form.attachments"></ui-input-file>
            <ui-textarea autoresize label="Notes" name="notes" :error="form.errors.get('notes')"
                         v-model="form.notes" placeholder="Any notes from the inspection in here..."></ui-textarea>
        </ui-form-section>
        <div class="flex justify-end space-x-4">
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Add Inspection</ui-button-new>
        </div>
    </div>
</template>

<script>
import {Supplier} from '@models'
import {toFormData} from "../../utils";

export default {
    props: {
        equipment: Object,
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                try {
                    let data = toFormData(form);
                    console.log(data);
//                    let data = form.export()
                    await this.equipment.addLog(data)
                    await this.equipment.refresh()
                    form.reset()
                } catch (error) {
                    if (error.message === 'Date must be supplied') {
                        this.form.errors.errors.date = '"Date" is required'
                    } else if (error.message === 'Inspection Date cannot be in the future') {
                        this.form.errors.errors.date = '"Date" cannot be in the future'
                    }
                }
            }),
        }
    },
    methods: {
        async searchSuppliers(query) {
            return (await Supplier.search(query)).map(x => x.toDropdown())
        },
    },
}
</script>
